export var AgentSortType;
(function (AgentSortType) {
    AgentSortType[AgentSortType["USER_CREATION_DATE_ASC"] = 10] = "USER_CREATION_DATE_ASC";
    AgentSortType[AgentSortType["USER_CREATION_DATE_DESC"] = 20] = "USER_CREATION_DATE_DESC";
    AgentSortType[AgentSortType["USER_LAST_UPDATE_DATE_ASC"] = 30] = "USER_LAST_UPDATE_DATE_ASC";
    AgentSortType[AgentSortType["USER_LAST_UPDATE_DATE_DESC"] = 40] = "USER_LAST_UPDATE_DATE_DESC";
    AgentSortType[AgentSortType["USER_FIRST_NAME_ASC"] = 50] = "USER_FIRST_NAME_ASC";
    AgentSortType[AgentSortType["USER_FIRST_NAME_DESC"] = 60] = "USER_FIRST_NAME_DESC";
    AgentSortType[AgentSortType["USER_EMAIL_ASC"] = 70] = "USER_EMAIL_ASC";
    AgentSortType[AgentSortType["USER_EMAIL_DESC"] = 80] = "USER_EMAIL_DESC";
    AgentSortType[AgentSortType["CREATION_DATE_ASC"] = 100] = "CREATION_DATE_ASC";
    AgentSortType[AgentSortType["CREATION_DATE_DESC"] = 110] = "CREATION_DATE_DESC";
    AgentSortType[AgentSortType["LAST_UPDATE_DATE_ASC"] = 120] = "LAST_UPDATE_DATE_ASC";
    AgentSortType[AgentSortType["LAST_UPDATE_DATE_DESC"] = 130] = "LAST_UPDATE_DATE_DESC";
    AgentSortType[AgentSortType["LOCATION_ASC"] = 140] = "LOCATION_ASC";
    AgentSortType[AgentSortType["LOCATION_DESC"] = 150] = "LOCATION_DESC";
    AgentSortType[AgentSortType["PERMISSION_ASC"] = 160] = "PERMISSION_ASC";
    AgentSortType[AgentSortType["PERMISSION_DESC"] = 170] = "PERMISSION_DESC";
    AgentSortType[AgentSortType["LOCATION_ID_ASC"] = 420] = "LOCATION_ID_ASC";
    AgentSortType[AgentSortType["LOCATION_ID_DESC"] = 430] = "LOCATION_ID_DESC";
})(AgentSortType || (AgentSortType = {}));
//# sourceMappingURL=agent-sort-type.enum.js.map